import { IErrorResponse } from "./IErrorResponse";

export interface IBaseResponse {
    success: boolean
}

export function isSuccessResponse<T>(response: T | IErrorResponse): response is T {
    if (response) {
        return Object.keys(response).every(key => {
            if (key.toLowerCase() == "success")
                return key in response && Object.getOwnPropertyDescriptor(response, key)?.value == true;
            return key in response;
        });
    }
    return false;
}

export function isErrorResponse(response: IBaseResponse | any): response is IErrorResponse {
    return 'success' in response && 'errorMessage' in response && response.success == false;
}
